// extracted by mini-css-extract-plugin
module.exports =  {"youtube":"YouTube-K0Oh__youtube","youtube--is-video-activity":"YouTube-ZF5N__youtube--is-video-activity"};